import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { globalStyle, style, styleVariants } from '../layer.css';

export const postTagButtonContainer = style({
  cursor: 'pointer',
  ...typography['labelSm'],
  height: '34px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: `${space.s6}px ${space.s12}px`,
  color: themeVars.badge.foreground.primary,
  gap: space.s8,
  borderRadius: borderRadius.r32,
  border: 0,
  ':hover': {
    backgroundColor: themeVars.badge.primary.background.hover,
  },
  ':active': {
    backgroundColor: themeVars.badge.primary.background.active,
  },
  ':disabled': {
    cursor: 'default',
    backgroundColor: themeVars.badge.disabled.background,
    color: themeVars.badge.disabled.foreground,
  },
});

export const postTagButtonVariants = styleVariants({
  secondary: {
    backgroundColor: themeVars.badge.primary.background.idle,
  },
  ghost: {
    backgroundColor: 'transparent',
  },
});
export type PostTagButtonVariant = keyof typeof postTagButtonVariants;

export const postTagButtonWithStartIcon = style({ paddingLeft: space.s8 });
export const postTagButtonWithEndIcon = style({ paddingRight: space.s8 });

globalStyle(`.${postTagButtonContainer} :where(svg)`, {
  height: 20,
  width: 20,
});
